type CookieOptions = string | Record<string, string>;

const buildCookieOptions = (options: CookieOptions): string => {
    if (typeof options === 'string') {
        return options;
    }

    return Object.entries(options)
        .map(([ key, value ]) => `${key}=${value}`)
        .join(';');
};

export const setCookie = (name: string, value: string, options: CookieOptions = {
    path: '/',
}): void => {
    document.cookie = `${name}=${value}${options ? `;${buildCookieOptions(options)}` : ''}`;
};

export const getCookie = (name: string): string | null => {
    const cname = name + '=';
    const ca = document.cookie.split(';');
    for (let i = 0; i < ca.length; i++) {
        const c = ca[i].trim();
        if (c.indexOf(cname) >= 0) {
            return c.substring(cname.length, c.length);
        }
    }
    return null;
};

export const hasCookie = (name: string): boolean =>
    getCookie(name) !== null;

export const unsetCookie = (name: string): void =>
    setCookie(name, '', {
        path: '/',
        expires: '-1',
    });
